/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Faq_A3Inputs */

const en_to_yaml_faq_a3 = /** @type {(inputs: To_Yaml_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON has no comment syntax, so a JSON input never carries comments to preserve. If your data originally came from a commented YAML file, those comments were lost when it was converted to JSON, before reaching this tool.`)
};

const ko_to_yaml_faq_a3 = /** @type {(inputs: To_Yaml_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON에는 주석 문법이 없으므로 JSON 입력이 보존할 주석을 담고 있는 경우는 없습니다. 데이터가 원래 주석 달린 YAML 파일에서 왔다면, 그 주석은 이 도구에 도달하기 전에 JSON으로 변환될 때 사라졌습니다.`)
};

const ja_to_yaml_faq_a3 = /** @type {(inputs: To_Yaml_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON にはコメント構文がないので、JSON の入力が保存すべきコメントを持つことはありません。データがもともとコメント付きの YAML ファイル由来なら、そのコメントはこのツールに届く前、JSON に変換された時点で失われています。`)
};

/**
* | output |
* | --- |
* | "JSON has no comment syntax, so a JSON input never carries comments to preserve. If your data originally came from a commented YAML file, those comments were ..." |
*
* @param {To_Yaml_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_faq_a3 = /** @type {((inputs?: To_Yaml_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_faq_a3(inputs)
	if (locale === "ko") return ko_to_yaml_faq_a3(inputs)
	return ja_to_yaml_faq_a3(inputs)
});